import { DateTime } from 'luxon';
import React, { useState } from 'react';
import { Button, Card, CardBody, CardHeader, Col, Collapse, FormGroup, Input, Row } from 'reactstrap';
import { useExecutionInfo } from '../hooks/useExecutionInfo';
import { ExecutionStatus } from '../types';
import { confTypeToString } from '../utils/confTypeToString';
import { secondsToTimeString } from '../utils/secondsToTimeString';
import { toTitleCase } from '../utils/toTitleCase';
import DeleteExecModal from './DeleteExecModal';

const ExecutionInfoForm: React.FC<{ id: string }> = ({ id }) => {
  const [collapsed, setCollapsed] = useState(true)
  const { data } = useExecutionInfo(id)
  const [modalOpen, setModalOpen] = useState(false)

  return (
    <Row>
      <Col className="order-xl-1">
        <Card className="bg-secondary shadow">
          <CardHeader className="bg-white border-0">
            <Row className="align-items-center">
              <Col xs="8">
                <h3 className="mb-0">Execution Info</h3>
              </Col>
              <Col className="text-right" xs="4">
                <Button
                  size="sm"
                  color="primary"
                  onClick={() => {
                    setCollapsed(!collapsed)
                  }}
                >
                  {collapsed ? 'Expand' : 'Collapse'}
                </Button>
              </Col>
            </Row>
          </CardHeader>
          <Collapse isOpen={!collapsed}>
            <CardBody>
              {/* <h6 className="heading-small text-muted mb-4">
                Basic Info
              </h6> */}
              <div className="pl-lg-4">
                <Row>
                  <Col lg="6">
                    <FormGroup>
                      <label
                        className="form-control-label"
                      >
                        Conference Name
                      </label>
                      <Input
                        className="form-control-alternative"
                        type="text"
                        value={data?.execution.confName || '-'}
                        disabled
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="6">
                    <FormGroup>
                      <label
                        className="form-control-label"
                      >
                        Session Name
                      </label>
                      <Input
                        className="form-control-alternative"
                        type="text"
                        value={data?.execution.sessionName || '-'}
                        disabled
                        readOnly
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col lg="6">
                    <FormGroup>
                      <label
                        className="form-control-label"
                      >
                        Executed By
                      </label>
                      <Input
                        className="form-control-alternative"
                        type="text"
                        value={data?.execution.user.name || '-'}
                        disabled
                        readOnly
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="6">
                    <FormGroup>
                      <label
                        className="form-control-label"
                      >
                        Started At
                      </label>
                      <Input
                        className="form-control-alternative"
                        type="text"
                        value={data?.execution.startedAt ? DateTime.fromISO(data.execution.startedAt).toLocaleString(DateTime.DATETIME_MED) : '-'}
                        disabled
                        readOnly
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col lg="6">
                    <FormGroup>
                      <label
                        className="form-control-label"
                      >
                        Status
                      </label>
                      <Input
                        className="form-control-alternative"
                        type="text"
                        value={toTitleCase(data?.execution.status || '-')}
                        disabled
                        readOnly
                      />
                    </FormGroup>
                  </Col>
                  {data?.execution.status && [ExecutionStatus.completed, ExecutionStatus.error].includes(data.execution.status) && <Col lg="6">
                    <FormGroup>
                      <label
                        className="form-control-label"
                      >
                        Time Taken
                      </label>
                      <Input
                        className="form-control-alternative"
                        type="text"
                        value={secondsToTimeString(data.execution.timeTakenInSeconds)}
                        disabled
                        readOnly
                      />
                    </FormGroup>
                  </Col>}
                </Row>
                {
                  data?.execution?.type &&
                  <Row>
                    <Col lg="6">
                      <FormGroup>
                        <label
                          className="form-control-label"
                        >
                          Type
                        </label>
                        <Input
                          className="form-control-alternative"
                          type="text"
                          value={confTypeToString(data.execution.type)}
                          disabled
                          readOnly
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                }
                <Row>
                  <Col>
                    <Button color="danger" onClick={() => setModalOpen(true)}>
                      Delete
                    </Button>
                    <DeleteExecModal id={id} onClose={() => setModalOpen(false)} open={modalOpen} />
                  </Col>
                </Row>
              </div>
            </CardBody>
          </Collapse>
        </Card>
      </Col>
    </Row>
  );
}

export default ExecutionInfoForm
